export default function Nav() {
    return (
        <nav className="navbar navbar-expand-lg navbar-light bg-white">
            <a className="navbar-brand" href="https://www.decode.com/">
                <img src="/images/decode1.png" height="80px" style={{margin: "40px 0 0 40px"}} alt={'deCODE genetics'}/>
            </a>
        </nav>
    );
}